<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="CountMonitorViewInfo"
                        :filter_thousandth="['card_count']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="count_plan_sign" :label="$t('getapi[7436]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="duty_person" :label="$t('getapi[7454]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="plan_status_name" :label="$t('getapi[7455]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="start_count_date" :label="$t('getapi[4042]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="end_count_date" :label="$t('getapi[4062]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="card_count" :label="$t('getapi[7456]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="area_flag_name" :label="$t('getapi[7457]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div>
                        <el-button type="primary" size="mini" @click="enableInput">{{$t('getapi[7458]')}}</el-button>
                        <el-button type="primary" size="mini" @click="disableInput">{{$t('getapi[7459]')}}</el-button>
                        <el-button type="primary" size="mini" @click="verify">{{$t('getapi[7460]')}}</el-button>
                    </div>
                    <table>
                        <tr>
                            <td  colspan="5">
                                <el-divider content-position="left">{{$t('getapi[7461]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px;min-width:60px">{{$t('getapi[7436]')}}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input v-model="dataDetail.Head.count_plan_sign" type="text" size="mini"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[4042]') }}</td>
                            <td style="width:180px;min-width:180px">
                                <el-date-picker v-model="dataDetail.Head.start_count_date" type="date" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>
                            <td>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[7454]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.duty_person" type="text" size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[3327]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.end_count_date" type="date" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>
                            <td>
                                <el-checkbox value="1" true-label='1' false-label='0'  disabled>{{ $t('getapi[7462]') }}</el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[7455]') }}</td>
                            <td>
                                <el-select v-model="dataDetail.Head.plan_status">
                                    <el-option :label="$t('getapi[7463]')" :value=0></el-option>
                                    <el-option :label="$t('getapi[7464]')" :value=1></el-option>
                                </el-select>
                            </td>
                            <td>{{$t('getapi[7456]')}}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.card_count" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5">
                                <el-divider content-position="left">{{$t('getapi[7465]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5">
                                <el-checkbox v-model="dataDetailRes.cardnojump" :true-label=1 :false-label=0  disabled>{{$t('getapi[7466]')}}</el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[7467]')}}</td>
                            <td>
                                <el-input v-model="dataDetailRes.totalmatchrate" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="CountMonitorViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6690]')" queryData="CountMonitorViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_countmonitor',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_countmonitor'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                code: '',
                dataDetail: {
                    Head: {},
                }, // 编辑页面数据详情
                dataDetailRes: {},
                oldDataDetail: '',
                timeId: null,
                oldrow: '',
                iscontinuedblclick: true,
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('3_countmonitor', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$limits.dragControllerDiv();
            that.confirmAdd();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('CountMonitorViewInfo',0,PFileds=>{
                    that.tableHeader=PFileds;
                });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6690]"),this.$t("getapi[979]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                  //管理界面			 
                if (that.$limits.authority('plv3', 467, 1) == 0) {
                    if(that.total>0){
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    else{
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                else if (that.$limits.authority('plv3', 467, 1) == 1) {			  
                    //编辑级
                   if(that.total>0){                     
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                    }
                }
                else if (that.$limits.authority('plv3', 467, 1) == 2) {			  
                    //编辑级
                   if(that.total>0){                     
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                    }
                }
                else{
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
            },
           
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_countmonitor',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'CountMonitorViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Fin/Check/GetCountMonitorView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority() ;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                that.timeId = setTimeout(() => {
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                if(that.code == row.count_plan_sign){
                                    return
                                }
                                that.addoredit = 2;
                                that.code = row.count_plan_sign
                                that.getDetail(row.count_plan_sign);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        if(that.code == row.count_plan_sign){
                            return
                        }
                        that.addoredit = 2;
                        that.code = row.count_plan_sign
                        that.getDetail(row.count_plan_sign);
                    }

                }, 100);
            },
            // 获取详情数据
            getDetail(count_plan_sign) {
                let that = this;
                console.log("唯一号1："+count_plan_sign);
                that.dataDetailRes = {}
                let parm = {
                    Code: count_plan_sign
                };
                that.$http.urlpost('/Fin/Check/GetCountMonitorInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                    }
                });
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Head: {
                        count_plan_sign: '',
                        duty_person: '',
                        start_count_date: datetime,
                        end_count_date: datetime,
                        area_flag: '',
                        card_count: '',
                        remark: '',
                        plan_status: '',
                        create_person: '',
                        isadd: 1
                    },
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                console.log("唯一号:"+that.code);
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if (!that.$limits.fnIsEmpty(that.code)) {
                                that.getDetail(that.code)
                            }
                            else{
                                that.confirmAdd()
                            }
                        });
                } else {
                    // if(that.isEdit){
                        that.getView();
                        if (!that.$limits.fnIsEmpty(that.code)) {
                            that.getDetail(that.code)
                        }
                        else{
                            that.confirmAdd()
                        }
                    // } else {
                    //     that.getView();
                    //     that.getDetail(that.code)
                    //     that.confirmAdd()
                    // }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Fin/Check/GetCountMonitorViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "CountMonitorViewInfo",
                    fromname: that.$t('getapi[6690]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = that.dataDetail.Head;
                parm.LangType= that.$processdata.getLang()
                that.$http.urlpost('/Fin/Check/SavetCountMonitor', parm, function (res) {
                    if (res.Success == 1) {
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
                that.$refs.SetBtn.SetOneBtnEnable('save', true);
            },
            enableInput(){
              let that = this
              let parm = {
                  Code: that.code
              }
                that.$http.urlpost('/Fin/Check/CountMonitorEnableInput', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            disableInput(){
                let that = this
                let parm = {
                    Code: that.code
                }
                that.$http.urlpost('/Fin/Check/CountMonitorDisableInput', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            verify(){
                let that = this
                let parm = {
                    Code: that.code,
                    LangType:that.$processdata.getLang(),
                }
                that.$http.urlpost('/Fin/Check/CountMonitorVerify', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.dataDetailRes = res.DataContent.entity
                    }
                });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 467,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .gray {
        background: #cac6c6;
    }
</style>
